import { Button, Row, Col, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { createMTE, getMTEById, updateMTE } from '../../../../services/MTEService';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useLoader } from '../../../../context/LoaderCotext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { connect, useDispatch } from 'react-redux';
import { getUsersSearch } from '../../../../services/BoxService';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { useEffect, useState } from 'react';
import AsyncSelect from 'react-select/async';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';

const validationSchema = Yup.object().shape({
  employee: Yup.string().required('Required'),
  manager: Yup.string().required('Required'),
  contract: Yup.string().required('Required'),
});

const UpdateMTE = ({ employeeList }) => {
  const [initialValues, setInitialValues] = useState({
    employee: '',
    manager: '',
    contract: '',
  });
  const [employeeDefault, setEmpListDefault] = useState([]);
  const [employeeDefault2, setEmpListDefault2] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { id } = useParams();

  useEffect(() => {
    const fetchRoom = async () => {
      try {
        const mte = await getMTEById(id);
        getUsersSearch(mte.employee.split('@')[0].split('.')[0])
          .then((response) => {
            const options = response.data.map((employee) => ({
              value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
              label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
              email: employee.email,
            }));
            setEmpListDefault(options);
          })
          .catch((error) => {
            console.error('Error fetching employee data 2', error);
          });
        getUsersSearch(mte.manager.split(' ')[0])
          .then((response) => {
            const options = response.data.map((employee) => ({
              value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
              label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
              email: employee.email,
            }));
            setEmpListDefault2(options);
          })
          .catch((error) => {
            console.error('Error fetching employee data 2', error);
          });
        setInitialValues({
          employee: mte.employee,
          manager: mte.manager,
          contract: mte.contract,
        });
      } catch (error) {
        console.error('Error fetching manager to employee details', error);
      }
    };

    fetchRoom();
  }, [id]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const { showLoader, hideLoader } = useLoader();

  const handleSubmit = async (values) => {
    showLoader();
    try {
      await updateMTE(id, values);
      // Show success toast notification
      toast.success('MTE Update Successfully!', {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000, // Closes after 3 seconds
      });
      // Delay navigation to ensure toast is visible
      setTimeout(() => {
        navigate('/settings/mte/');
      }, 3000);
    } catch (error) {
      console.error('Error updatting manager to employee', error);
    } finally {
      hideLoader();
    }
  };

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  return (
    <div>
      <Card>
        <h1>Update Manager To User</h1>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, errors, touched, isSubmitting }) => (
            <Form>
              <Row className="mb-3 mt-3">
                <Col>
                  <div className="form-group" id="employee">
                    <label>Employee</label>

                    <Field name="employee">
                      {({ field }) => (
                        <AsyncSelect
                          {...field}
                          value={employeeDefault.find(
                            (e) =>
                              e.email === values.employee ||
                              e.email.split('@')[0].toLowerCase() === values.employee.toLowerCase()
                          )}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={employeeList}
                          placeholder="Select employee..."
                          className="react-select-container"
                          classNamePrefix="react-select"
                          onChange={(selectedOption) => {
                            setFieldValue('employee', selectedOption.email);
                          }}
                        />
                      )}
                    </Field>

                    {errors.employee && touched.employee && (
                      <div className="text-danger">{errors.employee}</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div id="manager">
                    <label>Manager</label>
                    <Field name="manager">
                      {({ field }) => (
                        <AsyncSelect
                          {...field}
                          value={employeeDefault2.find((e) => e.label === values.manager)}
                          cacheOptions
                          loadOptions={loadOptions}
                          defaultOptions={employeeList}
                          placeholder="Select Manager..."
                          className="react-select-container"
                          classNamePrefix="react-select"
                          onChange={(selectedOption) => {
                            setFieldValue('manager', selectedOption.label);
                          }}
                        />
                      )}
                    </Field>
                    {errors.manager && touched.manager && (
                      <div className="text-danger">{errors.manager}</div>
                    )}
                  </div>
                </Col>
                <Col>
                  <div id="contract">
                    <label>Contract</label>
                    <Field
                      type="text"
                      name="contract"
                      placeholder="Enter Contract"
                      className="form-control"
                    />
                    {errors.contract && touched.contract && (
                      <div className="text-danger">{errors.contract}</div>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end m-2">
                <Button variant="primary" type="submit" disabled={isSubmitting}>
                  Update
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Card>

      {/* Toast Notification Container */}
      <ToastContainer />
    </div>
  );
};

const mapStateToProps = (state) => ({
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps, {})(UpdateMTE);
